<template>
  <div class="kee-recommend-box">
    <div class="title">
      {{ $t('recommendTitle') }}
    </div>
    <el-input :placeholder="$t('please_input')" v-model="searchInput" class="input-with-select" size="large">
      <el-button slot="append" icon="el-icon-search" @click="getTable"></el-button>
    </el-input>

    <div class="list-wrap">
      <div v-for="item in courseList" :key="item.courseId" class="recommend-list"  @click="goDetail(item)">
        <img :src="item.coverImgUrl" class="cov-img" alt="">
        <div class="info">
          <div>
            <div class="name">
              {{ item.title }}
              <div :class="['isNew', $i18n.locale === 'en' ? '__en' : '']" v-if="item.newCourseFlag"></div>
            </div>
            <p v-show="item.form === 'ONLINE'" class="duration">
              {{ $t('kee_duration') }}: {{ durationTrans(item.sumDurationFormat) }}
            </p>
          </div>
          <p class="tag">
            <el-tag type="primary" size="mini">
              {{ item.form }}
            </el-tag>
            <el-tag :type="item.chargeType === 'FREE' ? 'success' : 'danger'" size="mini" style="margin-left: 10px;">
              {{ item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
            </el-tag>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      searchInput: '',
      courseList: [],
      loading: false,
    }
  },
  inject: ['reload'],
  methods: {
    goDetail(item) {
      this.$router.replace({
        name: 'courseDetailNew',
        query: {
          courseId: item.courseId,
        }
      }, () => {
        this.reload();
      })
    },
    durationTrans(v) {
      return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
    },
    getTable(activeName) {
      // if (this.activeName == 'OFFLINE') {
      //   this.courseList = []
      //   this.pagination.total = 0
      //   return
      // }
      this.loading = true
      let param = {
        // kccTag: this.activeName,
        fuzzy: this.searchInput,
        // form: 'OFFLINE', // ONLINE / OFFLINE
        pageNum: 1,
        pageSize: 99,
      }
      API.insights.queryCourseInfo(param).then((res) => {
        if (res.code === '1') {
          this.courseList = res.data.records || []
          // this.pagination.total = res.data.total
        } else {
          this.$message.error(this.$t(res.code))
        }
        this.loading = false
      })
    },
  },
  mounted() {
    this.getTable()
  },
}
</script>

<style>
.kee-recommend-box .list-wrap::-webkit-scrollbar {
  width: 8PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8PX !important;
}

.kee-recommend-box {
  height: 100%;
}

.kee-recommend-box .title {
  font-size: 14PX;
  font-weight: 600;
  margin-bottom: 10px;
}

.kee-recommend-box .list-wrap {
  height: calc(100% - 60px);
  overflow-y: auto;
}

.recommend-list {
  display: flex;
  margin-top: 15px;
  cursor: pointer;
}

.recommend-list img {
  width: 100px;
  height: 130px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 15px;
}

.recommend-list .info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 0;
}
.recommend-list .info .el-tag {
  font-size: 12PX;
  line-height: 22PX;
  padding: 0 5PX;
  height: 22PX;
}

.recommend-list .info .name {
  font-size: 13PX;
  font-weight: 600;
  position: relative;
}

/* .recommend-list .info .name .isNew {
    position: absolute;
    padding: 2px 4px;
    left: -30px;
    top: -10px;
    color: white;
    background-color: #00b8f5;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 5px;
    font-size: 12PX;
} */

.recommend-list .info .name .isNew {
    display: inline-block;
    position: absolute;
    background: url("~@/assets/img/kpicon-new-6.png") center center/100% 100% no-repeat;
    


    width: 58PX;
    height: 28PX;
    left: -50PX;
    top: -15PX;
}

.recommend-list .info .name .isNew.__en {
  width: 40PX;
  height: 25PX;
  left: -30PX;
  top: -15PX;
  background: url("~@/assets/img/kpicon-new-3.png") center center/100% 100% no-repeat;
}

.recommend-list .info .duration {
  color: #ccc;
  font-size: 12px;
}
</style>
